import { Stack } from '@mui/material';
import { FILTER_TYPES } from 'common/constants/filters';
import SingleFilterSelector from 'components/FilterMenus/components/SingleFilterSelector';
import { StyledSectionTitle } from './CreateEditProjectModal.style';

const BoardsSelector = ({ selectedBoards, onChange, customFieldsMapper }) => {
  return (
    <Stack spacing={0.5} marginBottom={3}>
      <StyledSectionTitle className='mandatory'>Jira Board</StyledSectionTitle>
      <SingleFilterSelector
        filterType={FILTER_TYPES.BOARD}
        selectedFilters={selectedBoards}
        onChange={onChange}
        customFieldsMapper={customFieldsMapper}
      />
    </Stack>
  );
};

export default BoardsSelector;
